import React, {Component} from 'react'
import { Row, Col, Icon, Button, Select, Modal} from 'antd';
import { Link } from "react-router-dom";
import {connect} from 'react-redux';
import axios from 'axios';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser, selectAspirante } from '../../redux/user/user-selectors';
import Template from '../interfaz/Template';
import '../../css/administrarRegistro.css';
import AuthenticatedComponent from '../AuthenticatedComponent';
import errorImgModal from '../../img/error_icon.svg';
import icono_exito from '../../img/icono_exito.png';
import icono_basura from '../../img/icono_basura.png';
import infow_iconModal from '../../img/infow_icon.png';
import IconoAtras from '../../img/icons/arrow-left-circle-fill.svg';
import { verifiedToken } from '../../utils/funciones.js';
import {
    gral_error_cau, general_lbl_regresar, gral_error_administrador, etiqueta_bandeja_por_validar, etiqueta_validar_correo, etiqueta_registrado, etiqueta_declinado, etiqueta_finalizado, etiqueta_bandeja_con_observaciones, etiqueta_acudir_JDE, etiqueta_quitar_sede_examen,
    KEY_BANDEJA_REGISTRADOS, KEY_BANDEJA_POR_VALIDAR, KEY_BANDEJA_CON_OBSERVACIONES, KEY_BANDEJA_ACUDEN_JDE, KEY_BANDEJA_DECLINADOS, KEY_BANDEJA_FINALIZADOS, ESTATUS_REGISTRADO, ESTATUS_CON_DOCUMENTOS,
    ESTATUS_APROBADO, ESTATUS_DECLINADO, ESTATUS_DECLINADO_ASPIRANTE, ESTATUS_QUITAR_SEDE, ESTATUS_VALIDAR_CORREO, ESTATUS_COMPULSADO, KEY_BANDEJA_CON_DOCUS_ACUDE_JDE, KEY_BANDEJA_SIN_DOCUS_ACUDE_JDE, ETIQUETA_ESTATUS_ACUDE_JDE, ETIQUETA_ESTATUS_REGISTRADO_SIN_CORREO, ETIQUETA_ESTATUS_REGISTRADO_CON_CORREO, ETIQUETA_ESTATUS_POR_VALIDAR, ETIQUETA_ESTATUS_CON_OBSERVACIONES, ETIQUETA_ESTATUS_FINALIZADO_SIN_SEDE, ETIQUETA_ESTATUS_FINALIZADO_CON_SEDE, ETIQUETA_ESTATUS_DECLINADO_POR_JDE, ETIQUETA_ESTATUS_DECLINADO_POR_ASPIRANTE, ETIQUETA_ESTATUS_SIN_DEFINIR, ADMINISTRAR_REGISTRO_MENSAJE_EVALUACION_CURRICULAR, ADMINISTRAR_REGISTRO_MENSAJE_COMPULSA_POSITIVA
} from '../../ApplicationResources';
import { selectProceso } from '../../redux/menu/menu-selectors';
import { obtenerIpCliente } from '../../utils/funciones';

let msjError = "";
const rolesCaptura =  [ "SCE.ADMIN.OC", "SCE.UNICOM.OC", "SCE.CAPTURA.OC", "SCE.CAPTURA.JD", "SCE.CAPTURA_VCEYEC.JD" ];
const {Option} = Select;

class AdministrarRegistro extends Component {

    constructor(props) {
        super(props);

        this.state = {
            datosAspirante : this.props.datosAspirante || {},
            mostrarOcultarCambioEstatus: false,
            claveRepetida: false,
            numConv: 0,
            estatusActual: "",
            cambioEstatus: [],
            selectEstatus: false,
            guardar: true,
            valueSelect: null,
            cargando: false,
            modalOk: false,
            modalEliminar: false,
            mostrarConfirmacion: false,
            msjError: "",
            abrirModalError: false,
            abrirModalPermisos: false,
            tieneEvaluacionIntegral : true,
            abrirModalInfoW : false,
            mensajeModalInformativo : "",
            compulsaPositiva : false
        };
    }
    componentWillMount=() =>{
        this.setState({modalReenvioOk: false});
    }

    listo = () => {
        const datosAspirante = this.props.datosAspirante;

        if (!datosAspirante) {
            this.props.history.push('/bandeja');
            return;
        }

        if(!rolesCaptura.includes(this.props.datosUsuario.rolUsuario)){
            this.setState({abrirModalPermisos: true})
        }

        this.consultarEvaluacionIntegral(datosAspirante);

        this.setState({
            compulsaPositiva : this.props.datosAspirante.compulsaPositiva === 'S'
        })

        if(this.props.datosAspirante.compulsaPositiva === 'S')
            this.setState({
                abrirModalInfoW: true,
                mensajeModalInformativo: ADMINISTRAR_REGISTRO_MENSAJE_COMPULSA_POSITIVA
            });
    }

    consultarEvaluacionIntegral = (datosAspirante) => {
        axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/tieneEvaluacionIntegral', {
            idProcesoElectoral: this.state.datosAspirante.idProcesoElectoral
            , idDetalleProceso: this.state.datosAspirante.idDetalleProceso
            , idParticipacion : this.state.datosAspirante.idParticipacion
            , idAspirante : this.state.datosAspirante.idAspirante
        },{
            responseType: 'application/json',
            headers : {Authorization: localStorage.getItem('jwt-token')}
        }).then(res => {
            this.setState({
                tieneEvaluacionIntegral:res.data.tieneEvaluacionIntegral
            });

            if(res.data.tieneEvaluacionIntegral === true) {
                this.setState({
                    abrirModalInfoW: true,
                    mensajeModalInformativo : ADMINISTRAR_REGISTRO_MENSAJE_EVALUACION_CURRICULAR
                });
            }

            this.estatusActual(datosAspirante);
            this.verificaClaveRepetida(datosAspirante);
            this.asignarEstatus(datosAspirante);
        });
    }

    verificaClaveRepetida=(datosAspirante)=>{
        axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/esClaveRepetida', {
            //Se toma información de proceso seleccionado
            idProcesoElectoral: datosAspirante.idProcesoElectoral,
            idDetalleProceso: datosAspirante.idDetalleProceso,
            idParticipacion: datosAspirante.idParticipacion,
            idConvocatoria: datosAspirante.idConvocatoria,
            folio: datosAspirante.folio,
            claveElectorFuar: datosAspirante.claveElectorFuar
        },{
            responseType: 'application/json',
            headers : {Authorization: localStorage.getItem('jwt-token')}
        }).then(res => {
            if(res.data.esClaveRepetida === true){
                this.setState({claveRepetida: true});
            }else{
                this.setState({claveRepetida: false});
            }
        });
    }

    /******Asigna el estatus actual del aspirante******/
    estatusActual=(datosAspirante)=>{
        const estatusRegistro = datosAspirante.estatusRegistro;
        const bObservacion = datosAspirante.bObservacion;
        const bAcudirJDE = datosAspirante.bAcudirJDE;
        const bValidaCorreo = datosAspirante.bValidaCorreo;
        const sedeExamen = datosAspirante.idSedeProgramada;

        // Se establece inicialmente el estatus sin definir, en caso de que alguna combinación no se encuentre considerada a continuación
        this.setState({estatusActual: ETIQUETA_ESTATUS_SIN_DEFINIR});

        // El aspirante debe acude a jde y no está en estatus declinado por la jde o por él mismo
        if(bAcudirJDE && bAcudirJDE === 1 && !(estatusRegistro === ESTATUS_DECLINADO || estatusRegistro === ESTATUS_DECLINADO_ASPIRANTE)) {
            this.setState({estatusActual: ETIQUETA_ESTATUS_ACUDE_JDE});
        } else {
            if(estatusRegistro === ESTATUS_REGISTRADO) {
                // Estatus 1 - Aspirante registrado
                if(bValidaCorreo === null || bValidaCorreo === undefined || bValidaCorreo === 0)
                    this.setState({estatusActual: ETIQUETA_ESTATUS_REGISTRADO_SIN_CORREO});
                else
                    this.setState({estatusActual: ETIQUETA_ESTATUS_REGISTRADO_CON_CORREO});
            } else if(estatusRegistro === ESTATUS_CON_DOCUMENTOS) {
                // Estatus 2 - Aspirante con documentos (por validar)
                if(bObservacion === null || bObservacion === undefined || bObservacion === 0)
                    this.setState({estatusActual: ETIQUETA_ESTATUS_POR_VALIDAR});
                else
                    this.setState({estatusActual: ETIQUETA_ESTATUS_CON_OBSERVACIONES});
            } else if(estatusRegistro === ESTATUS_APROBADO) {
                // Estatus 3 - Aspirante finalizado (aprobado)
                if(sedeExamen === null || sedeExamen === undefined || sedeExamen === 0)
                    this.setState({estatusActual: ETIQUETA_ESTATUS_FINALIZADO_SIN_SEDE});
                else
                    this.setState({estatusActual: ETIQUETA_ESTATUS_FINALIZADO_CON_SEDE});
            } else if(estatusRegistro === ESTATUS_DECLINADO) {
                // Estatus 4 - Aspirante declinado por la JDE
                this.setState({estatusActual: ETIQUETA_ESTATUS_DECLINADO_POR_JDE});
            } else if(estatusRegistro === ESTATUS_DECLINADO_ASPIRANTE) {
                // Estatus 5 - Aspirante declinado (por él mismo)
                this.setState({estatusActual: ETIQUETA_ESTATUS_DECLINADO_POR_ASPIRANTE});
            }
        }
        
        axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/obtenerNoConvocatoria', {
            idDetalleProceso: datosAspirante.idDetalleProceso,
            idParticipacion: datosAspirante.idParticipacion,
            idConvocatoria: datosAspirante.idConvocatoria
        },{
            responseType: 'application/json',
            headers : {Authorization: localStorage.getItem('jwt-token')}
        }).then(res => {
            this.setState({numConv: res.data.numeroConvocatoria});
        })
    }
    
    /******Asigna los posibles cambios de estatus******/
    asignarEstatus = (datosAspirante) => {
        //  0 = Registrados, 1 = Por validar, 2 = Con observaciones, 3 = Acuden JDE, 4 = Declinados, 5 = Finalizados
        const estatusRegistro = datosAspirante.estatusRegistro;
        const bObservacion = datosAspirante.bObservacion;
        const bValidaCorreo = datosAspirante.bValidaCorreo;
        const bAcudirJDE = datosAspirante.bAcudirJDE;
        const bPlatica = datosAspirante.bPlatica;
        var esBandejaPorValidar = false;
        
        var cambiarEstatus = [];

        // Registrados, sin validacion de correo
        if (estatusRegistro === ESTATUS_REGISTRADO && bValidaCorreo === null) 
            cambiarEstatus.push({ value: ESTATUS_VALIDAR_CORREO, label: etiqueta_validar_correo });
        //Con observaciones
        if (estatusRegistro === ESTATUS_CON_DOCUMENTOS && bObservacion === 1 && bAcudirJDE !== 1)
            cambiarEstatus.push({ value: KEY_BANDEJA_ACUDEN_JDE, label: etiqueta_acudir_JDE });
        //Finalizado con sede
        if (estatusRegistro === ESTATUS_APROBADO && (bObservacion === 0 || bObservacion === null)  && datosAspirante.idSedeProgramada !== null) {
            cambiarEstatus.push({ value: ESTATUS_QUITAR_SEDE, label: etiqueta_quitar_sede_examen });
        }

        //Registro se encuentra en bandeja Por validar
        if (estatusRegistro === ESTATUS_CON_DOCUMENTOS && (bAcudirJDE === 0 || bAcudirJDE == null) && (bObservacion == 0 || bObservacion === null) && (bPlatica === null || bPlatica === 0)) {
            //cambiarEstatus.push({ value: KEY_BANDEJA_REGISTRADOS, label: etiqueta_registrado });
            esBandejaPorValidar = true;
         }
        //Registro se encuentra en bandeja Con observaciones
        if (estatusRegistro === ESTATUS_CON_DOCUMENTOS && bObservacion === 1 && bAcudirJDE === 0 && (bPlatica === null || bPlatica === 0)) {
            cambiarEstatus.push(/*{ value: KEY_BANDEJA_REGISTRADOS, label: etiqueta_registrado }, */{ value: KEY_BANDEJA_POR_VALIDAR, label: etiqueta_bandeja_por_validar });
        }
        //Registro se encuentra en bandeja Ciudadanos que acuden a JDE
        if ((estatusRegistro === ESTATUS_REGISTRADO || estatusRegistro === ESTATUS_CON_DOCUMENTOS) && (bPlatica === null || bPlatica === 0) && bAcudirJDE === 1) {
            if(datosAspirante && datosAspirante.tieneDocumentacion === 'S')
                cambiarEstatus.push({ value: KEY_BANDEJA_POR_VALIDAR, label: etiqueta_bandeja_por_validar });

            if (bObservacion === 1) 
                cambiarEstatus.push({ value: KEY_BANDEJA_CON_OBSERVACIONES, label: etiqueta_bandeja_con_observaciones });
        }
        //Registro se encuentra en bandeja Declinados
        if ((estatusRegistro === ESTATUS_DECLINADO || estatusRegistro === ESTATUS_DECLINADO_ASPIRANTE) && (bPlatica === null || bPlatica === 0)) {
            if(datosAspirante.tieneDocumentacion !== 'S' && bAcudirJDE !== 1)
                cambiarEstatus.push({ value: KEY_BANDEJA_REGISTRADOS, label: etiqueta_registrado });
            if(bValidaCorreo === 1 && datosAspirante.tieneDocumentacion === 'S' && bAcudirJDE !== 1)
                cambiarEstatus.push({ value: KEY_BANDEJA_POR_VALIDAR, label: etiqueta_bandeja_por_validar });
            if (bObservacion === 1)
                cambiarEstatus.push({ value: KEY_BANDEJA_CON_OBSERVACIONES, label: etiqueta_bandeja_con_observaciones });
        }
        //Registro se encuentra en bandeja de Finalizados
        if (estatusRegistro === ESTATUS_APROBADO && bAcudirJDE != 1) {
            cambiarEstatus.push(/*{ value: KEY_BANDEJA_REGISTRADOS, label: etiqueta_registrado },*/ { value: KEY_BANDEJA_POR_VALIDAR, label: etiqueta_bandeja_por_validar });
            if (bObservacion === 1)
                cambiarEstatus.push({ value: KEY_BANDEJA_CON_OBSERVACIONES, label: etiqueta_bandeja_con_observaciones });
            if (bAcudirJDE === 1)
                cambiarEstatus.push({ value: KEY_BANDEJA_ACUDEN_JDE, label: etiqueta_acudir_JDE });
        }
        //Registro no se encuentra en bandeja Declinados
        if (estatusRegistro !== ESTATUS_DECLINADO && estatusRegistro !== ESTATUS_DECLINADO_ASPIRANTE && !esBandejaPorValidar && !(estatusRegistro === ESTATUS_APROBADO && bAcudirJDE === 1))
            cambiarEstatus.push({ value: KEY_BANDEJA_DECLINADOS, label: etiqueta_declinado});

        cambiarEstatus = cambiarEstatus.sort((a, b) => a.value - b.value )
        this.setState({cambioEstatus: cambiarEstatus});
    }

    abrirCambioEstatus=()=>{
        this.setState(prevState => ({mostrarOcultarCambioEstatus: !prevState.mostrarOcultarCambioEstatus}));
    }

    onChange=(valueSelect)=> {
        console.log('valueSelect = ', valueSelect);
        this.setState({valueSelect, selectEstatus: true});
    }
    
    guardarEstatus = async() =>{
        this.setState({cargando: true});
        // Se obtiene la ip del cliente
        const ipCliente = await obtenerIpCliente()

        axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/administrarRegistro', {
            //Se toma información de proceso seleccionado
            idProcesoElectoral: this.state.datosAspirante.idProcesoElectoral
            , idDetalleProceso: this.state.datosAspirante.idDetalleProceso
            , idParticipacion : this.state.datosAspirante.idParticipacion
            , idAspirante : this.state.datosAspirante.idAspirante
            , folio : this.state.datosAspirante.folio
            , claveElectorFuar: this.state.datosAspirante.claveElectorFuar
            , selectValue: this.state.valueSelect
            , ipUsuario: ipCliente
        },{
            headers: {
                'Content-Type': 'application/json'
                , 'Authorization': localStorage.getItem("jwt-token")        
            }
        }).then(res => {
            if(res.data.code === 200){
                this.setState({cargando: false, guardar: false, modalOk:true});
            }
        }).catch(error => {
            this.setState({cargando: false});
            msjError = gral_error_administrador;
            this.setState({msjError: msjError, abrirModalError: true});
        });
    }

    confirmaEliminar=()=>{
        this.setState({mostrarConfirmacion: true})
    }
    cancelarConfirmacion = () => {
        this.setState({mostrarConfirmacion: false});
    }

    eliminarRegistro = async() => {
        this.setState({mostrarConfirmacion: false, cargando: true});
        // Se obtiene la ip del cliente
        const ipCliente = await obtenerIpCliente()

        axios.post(process.env.REACT_APP_API_URL + '/ws_reclutaseycae_central/ws/administrarEliminarRegistro', {
            //Se toma información de proceso seleccionado
            idProcesoElectoral: this.state.datosAspirante.idProcesoElectoral
            , idDetalleProceso: this.state.datosAspirante.idDetalleProceso
            , idParticipacion : this.state.datosAspirante.idParticipacion
            , idAspirante : this.state.datosAspirante.idAspirante
            , folio : this.state.datosAspirante.folio
            , claveElectorFuar: this.state.datosAspirante.claveElectorFuar
            , ipUsuario: ipCliente
        },{
            headers: {
                'Content-Type': 'application/json'
                , 'Authorization': localStorage.getItem("jwt-token")        
            }
        }).then(res => {
            if(res.data.code === 200){
                this.setState({cargando: false, guardar: false, modalEliminar:true});
            } else {
                this.setState({cargando: false});
                msjError = gral_error_administrador;
                this.setState({msjError: msjError, abrirModalError: true});                
            }
        }).catch(error => {
            this.setState({cargando: false});
            msjError = gral_error_administrador;
            this.setState({msjError: msjError, abrirModalError: true});
        });
    }

    cerrarOkModal= () =>{
        this.setState({modalOk: false});
        this.props.history.push('/bandeja');
        //window.location.reload(); //refresca la pantalla
        //window.location.href = window.location.href;
    }

    cerrarEliminarModal=()=>{
        this.setState({modalEliminar: false});
        this.props.history.push('/bandeja');
    }

    cerrarErrorModal=()=> {
        this.setState({abrirModalError:false});
        if(!rolesCaptura.includes(this.props.datosUsuario.rolUsuario) || this.props.datosAspirante.correo === null){
            this.props.history.push('/bandeja');
        }
    }

    cerrarInfoWModal=()=> {
        this.setState({abrirModalInfoW:false});
    }

    descargarBitacoraRegistro = e =>{
        //console.log(this.props);

        const { idAspirante , idProcesoElectoral,idDetalleProceso,idEstado,idDistrito,claveElectorFuar,folio : folioAspirante, nombre, apellidoPaterno, apellidoMaterno} = this.props.datosAspirante;
        const { descripcionDetalle } = this.props.proceso;

        let hd = { 'Accept': 'application/json','Content-Type': 'application/json'};
        hd = verifiedToken(hd);
        
                
        this.setState({cargando: true});
        axios.post(process.env.REACT_APP_API_URL +
            "/ws_reclutaseycae_central/ws/obtenerExcelBitacoraRegistro", {
                idAspirante,
                descripcionDetalle,
                idProcesoElectoral,
                idDetalleProceso,
                idEstado,
                idDistrito,
                claveElectorFuar,
                folioAspirante,
                nombreAspirante : `${nombre} ${apellidoPaterno ? apellidoPaterno : ""} ${apellidoMaterno ? apellidoMaterno : ""}`
                
            },{
                responseType: 'blob',
                transformResponse: [ data => {
                let blob = new window.Blob([data], {type: "application/vnd.ms-excel"});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', `Bitacora_registro.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link)
                }],
                headers:hd
                }
            ).then(res => {
                console.log(res);
                if(res.status === 200){
                    this.setState({cargando: false});
                } else {
                    this.setState({cargando: false});
                    msjError = gral_error_cau;
                    this.setState({msjError: msjError, abrirModalError: true});                
                }
        }).catch(error => {
            this.setState({cargando: false});
            msjError = gral_error_cau;
            this.setState({msjError: msjError, abrirModalError: true});
        });
    }

    render() {
        const datosAspirante = this.props.datosAspirante || {};

        return (
            <AuthenticatedComponent externo={false} listo={this.listo}>
            <Template contenido={
                <div className="contenedorReenvio">
                    <div className='boton-regresar'>
                        <Link to={`/bandeja`}>
                            <img className='img-regresar'
                                src={IconoAtras} 
                                alt="Atrás"/> 
                            <span className='etiqueta-regresar'>{general_lbl_regresar}</span>
                        </Link>
                    </div>

                    <div className="container_administrador">
                        <div style={{textAlign:'center'}}>
                            <span className='exito_titulo' style={{fontSize: '2em'}}><b> Administrar Registro </b></span> 
                        </div>
                        <br/>
                        <div className="datos_Registro">
                            <Row>
                                <Col xs={12} sm={2} md={6} lg={12}>
                                    <span className="titulo_admin">Aspirante</span>
                                </Col>
                                <Col xs={12} sm={2} md={6} lg={12}>
                                    <span className="estatusActual"><b>Estatus actual: </b> {this.state.estatusActual}</span>
                                </Col>
                            </Row>
                            <Row style={{padding: '10px 0'}}>
                                <Col xs={24} sm={2} md={6} lg={6}>
                                    <span className='datosAspirante_admin'><b>Nombre: </b> 
                                        {datosAspirante.nombre +" "+ (datosAspirante.apellidoPaterno ? datosAspirante.apellidoPaterno : "") +" "+ (datosAspirante.apellidoMaterno ? datosAspirante.apellidoMaterno : "")}</span>
                                </Col>
                                <Col xs={24} sm={2} md={6} lg={4}>
                                    <span className='datosAspirante_admin'><b>Folio: </b> {datosAspirante.folio}</span>
                                </Col>
                                <Col xs={24} sm={2} md={6} lg={6}>
                                    <span className='datosAspirante_admin'><b>Clave de elector: </b> {datosAspirante.claveElectorFuar}</span>
                                </Col>
                                <Col xs={24} sm={2} md={6} lg={4}>
                                    <span className='datosAspirante_admin'><b>Convocatoria: </b> {this.state.numConv}</span>
                                </Col>
                                <Col xs={24} sm={2} md={6} lg={4}>
                                    <span className='datosAspirante_admin'><b>Sección: </b> {datosAspirante.seccionDom}</span>
                                </Col>
                            </Row>
                        </div>
                        <br/><hr/><br/>
                        <center>
                            <Row>
                                <Col xs={24} sm={2} md={0} lg={6}/>
                                <Col xs={24} sm={2} md={6} lg={4}>
                                    <Button disabled={this.state.claveRepetida || this.state.tieneEvaluacionIntegral || this.state.compulsaPositiva}
                                            onClick={()=>this.abrirCambioEstatus()}>
                                                Modificar estatus
                                    </Button>
                                </Col>
                                <Col xs={24} sm={2} md={6} lg={4}>
                                    <Button disabled={(datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5) && this.state.tieneEvaluacionIntegral === false ? false : true} //disabled={!this.state.guardar}
                                            onClick={()=>this.confirmaEliminar()}
                                            >
                                                Eliminar registro
                                    </Button>
                                </Col>
                                <Col xs={24} sm={2} md={6} lg={4}>
                                    <Button
                                            onClick={e=>this.descargarBitacoraRegistro(e)}
                                            >
                                                Bitácora de registro
                                    </Button>
                                </Col>
                                <Col xs={24} sm={2} md={6} lg={6}/>
                            </Row>
                            <div className={this.state.mostrarOcultarCambioEstatus ? "show" : "hide"} id="div_Admin">
                                <Row>
                                    <Col xs={24} sm={0} md={0} lg={8}/>
                                    <Col xs={24} sm={24} md={24} lg={8}>
                                        <Select placeholder="Selecciona estatus"
                                                onChange={this.onChange}
                                                style={{ width: "100%" }}>
                                            {
                                                this.state. cambioEstatus &&
                                                this.state.cambioEstatus.map((opcion, index) => (
                                                    <Option key={index} value={opcion.value}>{opcion.label}</Option>
                                                ))
                                            }
                                        </Select>
                                    </Col>
                                    <Col xs={24} sm={0} md={0} lg={8}/>
                                </Row>
                                <br/><br/><br/>
                                <Row>
                                    <Col xs={24} sm={0} md={0} lg={8}/>
                                    <Col xs={24} sm={24} md={24} lg={8}>
                                        <Button style={{width:180, float:'right'}} 
                                                disabled={!this.state.selectEstatus}
                                                onClick={()=>this.guardarEstatus()}
                                                >
                                                    Guardar cambios
                                        </Button>
                                    </Col>
                                    <Col xs={24} sm={0} md={0} lg={8}/>
                                </Row>
                            </div>   
                                
                        </center>
                        <br/>
                    </div>                
                </div>
            }
            guia={false}
            cargando={this.state.cargando}
            />
                <Modal visible={this.state.modalOk} 
                       title={null}
                       onOk={()=>this.cerrarOkModal()}
                       onCancel={()=>this.cerrarOkModal()}
                       centered
                       width={307}
                       footer={null}>
                    <Row style={{padding: '10px 0'}}>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <img src={icono_exito} id="iconoAdmin"/></Col>
                        <Col xs={18} sm={18} md={18} lg={18}>
                            <p className="parrafoCentrado"> El registro ha sido actualizado</p>
                        </Col>
                   </Row>
                </Modal>
                <Modal visible={this.state.modalEliminar} 
                       title={null}
                       onOk={()=>this.cerrarEliminarModal()}
                       onCancel={()=>this.cerrarEliminarModal()}
                       centered
                       width={307}
                       footer={null}>
                    <Row style={{padding: '10px 0'}}>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <img src={icono_basura} id="iconoAdmin"/></Col>
                        <Col xs={18} sm={18} md={18} lg={18}>
                            <p className="parrafoCentrado"> El registro se eliminó correctamente</p>
                        </Col>
                   </Row>
                </Modal>
                <Modal visible={this.state.mostrarConfirmacion}
                       title={null}
                       centered
                       closable={false}
                       onOk={this.aceptarConfirmacion}
                       onCancel={this.cancelarConfirmacion}
                       footer={null}
                       width={340}>
                    <div className="mensaje_confirmacion">¿Está seguro de eliminar el registro?</div>
                        <br/>
                    <div id="modal_botones">
                        <Button className="botonesModal" style={{borderRadius: '5px'}} onClick={this.cancelarConfirmacion}>
                            Cancelar
                        </Button>
                        <Button className="botonesModal" style={{borderRadius: '5px'}} onClick={this.eliminarRegistro}>
                            Aceptar
                        </Button>
                        
                    </div>
                </Modal>
                <Modal className="modalError"
                       title={<img  src={errorImgModal} id="img-error-modal"/>}
                       centered
                       onCancel={()=>this.cerrarErrorModal()}
                       visible={this.state.abrirModalError}
                       footer={false}
                       width={400}>
                    {this.state.msjError}
                </Modal>
                <Modal
                    className="modalInformativo"
                    title={<img  src={infow_iconModal} id="img-error-modal"/>}
                    centered
                    onCancel={()=>this.cerrarInfoWModal()}
                    visible={this.state.abrirModalInfoW}
                    footer={false}
                    width={400}>
                    {this.state.mensajeModalInformativo}
                </Modal>
                <Modal
                    title={null}
                    footer={null}
                    centered={true}
                    visible={this.state.abrirModalPermisos}
                    onOk={()=>this.cerrarErrorModal()}
                    onCancel={()=>this.cerrarErrorModal()}>
                    <div>
                        <h3 style={{'textAlign': 'center'}}>PERMISOS INSUFICIENTES</h3>
                        <h5 style={{'textAlign': 'center'}}>No tiene permiso para realizar esta acción.</h5>
                    </div>
                </Modal>
            </AuthenticatedComponent>
        );
    }
};

const mapStateToProps = createStructuredSelector({
    datosUsuario: selectCurrentUser,
    datosAspirante: selectAspirante,
    proceso: selectProceso
  });

export default connect(mapStateToProps)(AdministrarRegistro);